import { render, staticRenderFns } from "./PricePerUnit.vue?vue&type=template&id=b91ee83c&scoped=true&"
import script from "./PricePerUnit.vue?vue&type=script&lang=ts&"
export * from "./PricePerUnit.vue?vue&type=script&lang=ts&"
import style0 from "./PricePerUnit.vue?vue&type=style&index=0&id=b91ee83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ee83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
